var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/Spinner/Spinner.js";
/* eslint-disable no-extra-parens */
import React from "react";
var Spinner = function Spinner() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: "survey-Spinner",
    "data-testid": "Spinner",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 8.36a9 9 0 1 1-2.5-3.28 1 1 0 0 0 1.28-1.54 11 11 0 1 0 3.05 4 1 1 0 0 0-1.83.82z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }));
};
export default Spinner;